module.exports = __webpack_public_path__ + "static/fonts/Poppins-SemiBold.6f1520d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-SemiBold.ttf
// module id = 1033
// module chunks = 11